export enum WorkerTypeSectionEnum {
  StatementFilesSection = 1,
  EmploymentHistoryFilesSection = 2,
  AdditionalFilesSection = 3,
  WorkerFamilyMemberSection = 4,
  EducationHistoryFilesSection = 5,
  RequestsAndCertificatesSection = 6,
}
